<!--
  一覧切り替えボタンを置きたい場所に以下のportal-targetを置いてください
  portal-target(name="list_mode", tag="span")

  TODO $parentに依存しすぎているのを解消したい
-->
<template lang="pug">
  .table-responsive(:class="{'mode-list': mode === 'list', 'mode-card': mode === 'card'}")

    portal(to="list_mode")
      .btn-group(data-toggle='buttons')
        .btn.btn-default(:class="{active: mode === 'list'}", @click="setMode('list')", title="リスト表示")
          i.fa.fa-list
        .btn.btn-default(:class="{active: mode === 'card'}", @click="setMode('card')", title="カード表示")
          i.fa.fa-th

    table.table.table-striped.table-bordered.bcard-table
      caption.bg-warning.check-all-mode(v-if="$parent.checkAllMode")
        template(v-if="$parent.checkAllMode === 'thisPage'")
          span このページの {{checkedIds.length}} 件が選択されています。
          //- 複数ページにまたがる場合
          template(v-if="$parent.pagination.page_count > 1")
            | &nbsp;&nbsp;|&nbsp;&nbsp;
            a(href="#" @click="$emit('checkAll', list, 2)") 全ページの {{$parent.pagination.count}} 件をすべて選択する。
        template(v-if="$parent.checkAllMode === 'allPages'")
          a(v-if="$parent.checkAllMode === 'allPages'" href="#" @click="$emit('checkAll', list, 1)") このページの {{list.length}} 件のみを選択する。
          | &nbsp;&nbsp;|&nbsp;&nbsp;
          span 全ページの {{$parent.pagination.count}} 件すべてが選択されています。

      thead
        tr
          th.bcard-table-td-chk(v-if="useCheckbox")
            label
              input(type="checkbox", @change="$emit('checkAll', list, $event.target.checked)")
          th.thd-img 名刺画像
          th.thd-name 氏名/会社名
            template(v-if="sort")
              i.fa.bcard-table-sort-header-icon(v-show="sort.sort_item === 'name' || sort.sort_item === 'corporate_name'", :class="'fa-sort-' + sort.direction")
          th.thd-group 部署名/役職
            template(v-if="sort")
              i.fa.bcard-table-sort-header-icon(v-show="sort.sort_item === 'dept' || sort.sort_item === 'post'", :class="'fa-sort-' + sort.direction")
          th.thd-contact 連絡先
          th.thd-address 住所
          th.thd-tags タグ
          th.thd-exchange
            //- 最近見た名刺で入れ替えるためslot化
            slot(name="thDate", :sort="sort")
              | 名刺交換日/交換者
              template(v-if="sort")
                i.fa.bcard-table-sort-header-icon(v-show="sort.sort_item === 'exchange_date'", :class="'fa-sort-' + sort.direction")
      tbody
        tr(v-for="(item, index) in list", :key="item.id", :class="{'selected': $parent.isChecked(item.id)}" :data-testid="item.full_name")
          td.bcard-table-td-chk(v-if="useCheckbox")
            label
              input(type="checkbox", :checked="$parent.isChecked(item.id)", @change="$emit('checkItem', item.id, $event.target.checked)")
          td.thd-img
            a(v-if="item.image_url.length !== 0" href="#" @click.prevent="showBcardImageModal(item.id)")
              img(:src="app_imgsrc.now_loading", v-src:thumbnail="item.image_url", :alt="item.full_name", :title="item.full_name")
            img(v-else :src="app_imgsrc.now_loading", v-src:thumbnail="item.image_url")
          td.thd-name
            func-favorite.pull-right(v-if="useFavorite", v-model="item.isFavorite", :sid-person="item.sid_person", icon="icon")
            router-link.text(:to="itemLocation(item)" data-testid="link-full-name")
              i.fa.bcard-fa-person-private(v-if="item.person && item.person.openflag === '0'" title="非公開")
              |
              | {{item.full_name}}
              br
              | {{item.corporate_name}}
            latest-label(:is-latest="item.is_latest")
          td
            div(v-if="item.dept") {{item.dept}}
            div(v-if="item.post") {{item.post}}
            div(v-if="item.dept_post") {{item.dept_post}}
          td
            .media(v-if="item.o1_tel1 || item.o1_mobile")
              .media-left
                i.fa.fa-fw.fa-phone
              .media-body
                div(v-if="item.o1_tel1") {{item.o1_tel1}}
                div(v-if="item.o1_mobile") {{item.o1_mobile}}
            .media(v-if="item.o1_mail")
              .media-left
                i.fa.fa-fw.fa-envelope-o
              .media-body
                a(:href="'mailto:' + item.o1_mail") {{item.o1_mail}}
          td
            .media(v-if="item.o1_zipcode || item.o1_address1 || item.o1_address2")
              .media-left
                i.fa.fa-fw.fa-map-marker
              .media-body
                div(v-if="item.o1_zipcode") 〒{{item.o1_zipcode}}
                div(v-if="item.o1_address1 || item.o1_address2")
                  address-link(:addresses="[item.o1_address1, item.o1_address2]")
          td.thd-tags
            selected-tag(v-model="item.tags", :view_mode="true")
          td
            //- 最近見た名刺で入れ替えるためslot化
            slot(name="tdDate", :item="item")
              | {{item.formatted_exdate}}
              br
              exchanger-names(:exchanges="item.exchanges")

    //- 名刺画像ダイアログ
    modal-images(v-model="modalImages")
</template>

<script>
import SelectedTag from '@/components/molecules/SelectedTag'
import FuncFavorite from '@/components/organisms/functions/FuncFavorite'
import LatestLabel from '@/components/molecules/LatestLabel'
import AddressLink from '@/components/molecules/AddressLink'
import ExchangerNames from '@/components/molecules/ExchangerNames'
import ModalImages from '@/components/organisms/ModalImages'

export default {
  name: 'CardList',
  components: { SelectedTag, FuncFavorite, LatestLabel, AddressLink, ExchangerNames, ModalImages },
  props: {
    value: { type: Array, required: true },
    pCheckedIds: { type: [Array, Boolean], required: false, default: false },
    sort: {
      type: Object,
      required: false,
      default () {
        return {
          // ページ条件
          // page: { page: 1 },
          // ソート条件
          sort: {},
          // 検索条件
          conds: {}
        }
      }
    },
    useFavorite: { type: Boolean, required: false, default: false },
    itemLocation: {
      type: Function,
      required: false,
      default (item) {
        let location = { name: '', params: { sidPerson: item.sid_person, item } }

        if (item.is_latest === this.app_flag.ON) {
          location.name = 'box-detail'
        }
        else {
          location.name = 'box-history-detail'
          location.params.sidBcard = item.id
        }

        return location
      }
    }
  },
  data () {
    return {
      /**
       * list: 一覧表示
       * card: カード表示
       */
      mode: '',
      list: [],
      checkedIds: [],
      useCheckbox: false,
      // 名刺画像ダイアログ
      modalImages: {
        isOpen: false,
        sid_bcard: null
      }
    }
  },
  watch: {
    pCheckedIds (pCheckedIds) {
      this.syncCheckedIds(pCheckedIds)
    },
    value (value) {
      this.syncList(value)
    }
  },
  created () {
    this.setMode() // 引数なしで初期設定を行う
    this.syncCheckedIds(this.pCheckedIds)
    this.syncList(this.value)
    // this.setMockData()
  },
  methods: {
    /**
     * 一覧の表示モードを設定する
     * @param mode 'list', 'card', 空（storeからセット。デフォルトはlist）
     */
    setMode (mode) {
      // 読み込み
      if (!mode) {
        this.mode = this.$store.getState('listMode') || 'list'
      }
      // 書き込み
      else {
        this.mode = mode
        this.$store.commit('setListMode', mode)
      }
    },
    syncCheckedIds (checkedIds) {
      this.useCheckbox = (checkedIds !== false)
      if (this.useCheckbox) {
        this.checkedIds = checkedIds
      }
    },
    syncList (list) {
      this.list = list
    },
    // 名刺画像ダイアログ表示
    showBcardImageModal: function (sid_bcard) {
      this.modalImages.isOpen = true
      this.modalImages.sid_bcard = sid_bcard
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '~bootstrap-sass/assets/stylesheets/bootstrap/variables';

  .check-all-mode {
    position: relative; // absoluteだとtheadとtbodyの間に余計な線が出るバグ
    z-index: 1;
    margin: 0 0 -35px 43px;
    width: calc(100% - 43px);
  }

  /**
   * チェックボックスの反応範囲を広げる
   */
  .bcard-table-td-chk {
    position: relative;
    min-height: 38px;

    label {
      margin: 0;
      padding: 0;
      cursor: pointer;
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0;

      /* radioを上下中央に配置する */
      display: flex;
      align-items: center;
      justify-content: center;

      &:hover {
        background-color: #f4f4f5;
      }
    }
  }

  .mode-card {
    .bcard-table {
      thead {
        th {
          display: none;
        }

        th.bcard-table-td-chk {
          display: block;
          text-align: left;
          width: 100%;

          label {
            display: block; // flex取り消し
            padding: 8px 15px;
            line-height: 19px;

            &:after {
              content: 'すべて選択';
              margin-left: 1.2em;
            }
          }
        }
      }

      tbody {
        display: flex;
        flex-wrap: wrap;
        align-items: stretch;
        padding: 10px;

        tr {
          margin: 5px;
          width: calc(100% - 10px);
          display: block;
          border: 1px solid #ddd;
          border-radius: 10px !important;
          background-color: inherit;
        }

        @media (min-width: $screen-sm-min) {
          tr {
            width: calc(50% - 10px);
          }
        }

        @media (min-width: $screen-lg-min) {
          tr {
            width: calc(33.333% - 10px);
          }
        }

        td {
          display: block;
          border: 0;
          width: 100%;

          &.thd-img {
            text-align: center;

            img {
              height: 75px;
            }
          }
        }

        .bcard-table-td-chk label {
          border-top-left-radius: 10px;
          border-top-right-radius: 10px;
        }
      }
    }
  }

  // 電話番号
  td .media {
    margin-top: 0;
    .media-left {
      padding-right: 5px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/organisms/lists/CardList.vue